<template>
<div class="MilestoneOverlayDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-5Perc cursor-pointer " v-on:click="closeMileStoneOverlay">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                  <div class="col-md-4 col-lg-4">
                  </div>  
                  <div class="col-md-4 col-lg-4 text-align-center">
                    <button type="button" class="btn gray-border white-BG" v-on:click="updateCreateMilestoneDropDownFlag">+ Create New</button>
                  </div>
                  <div class="col-md-4 col-lg-4">
                  </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="showCreateMilestoneDropDownUI">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Milestone Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="getSelectedMilestoneInfoObj">
                        <option value=-1 disabled>Select</option>
                        <option v-for="milestoneObj in getMilestoneInfoList" v-bind:key="milestoneObj.MilestoneInfoId" v-bind:value="milestoneObj"> {{milestoneObj.Title}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <!-- AK: Start of For showing bottom border -->
              <div class="row margin-bottom-2Perc" v-if="showCreateMilestoneDropDownUI">
                  <div class="col-md-1 col-lg-1"></div>
                  <div class="col-md-10 col-lg-10 grey-bottom-border"></div>
                  <div class="row col-md-1 col-lg-1"></div>
              </div>
              <!-- End of For showing bottom border -->
              <div class="table-responsive margin-Top-6Perc overflow-x-hidden margin-bottom-2Perc" v-if="getExistingMilestoneList.length > 0 && !showingCreateOrUpdateOverlay">
                <table class="table table-striped ">
                  <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right">Group Name</th>
                      <th class="text-align-center font-size-15px border-right">Milestone Type</th>
                      <th class="text-align-center font-size-15px border-right">Milestone Title</th>
                      <th class="text-align-center font-size-15px">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="existingMilestoneObj in getExistingMilestoneList" :key="existingMilestoneObj.MilestoneId" :existingMilestoneObj="existingMilestoneObj" >
                      <td class="border-right">{{getCurrentSelectedGroupObj.GroupName}}</td>
                      <td class="border-right">{{getMilestoneNameUsingMilestoneId(existingMilestoneObj)}}</td>
                      <td class="border-right">{{existingMilestoneObj.Title}}</td>
                      <td>
                        <a class="cursor-pointer" @click="performClickOperation($event,'action', existingMilestoneObj)"> Milestone Actions  </a>|  
                        <a class="cursor-pointer" @click="performClickOperation($event,'update', existingMilestoneObj)"> Edit  </a>|
                        <a class="cursor-pointer" @click="performClickOperation($event,'delete', existingMilestoneObj)"> Delete</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row margin-bottom-2Perc" v-else>
                <div class="col-sm-12">
                  <span class="opacity font-weight-bold">No Milestone(s) were found for <i>"{{getCurrentSelectedGroupObj.GroupName}}"</i> group.</span> 
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeMileStoneOverlay">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <milestone-action-overlay v-if="showMilestoneActionOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :currSelectedMilestoneObjFromList="currSelectedExistingMilestoneObjFromList" @closeOverlay="handleCloseOverlay"></milestone-action-overlay>

      <create-cumulative-progress-type-milestone-overlay v-if="showCreateCumulativeProgressTypeMilestoneOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :selectedMilestoneInfoObj="getSelectedMilestoneInfoObj" @closeOverlay="handleCloseOverlay"></create-cumulative-progress-type-milestone-overlay>
      <update-cumulative-progress-type-milestone-overlay v-if="showUpdateCumulativeProgressTypeMilestoneOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :currSelectedMilestoneObjFromList="currSelectedExistingMilestoneObjFromList" @closeOverlay="handleCloseOverlay"></update-cumulative-progress-type-milestone-overlay>
      <create-specific-element-completion-type-milestone-overlay v-if="showCreateSpecificElementCompletionTypeMilestoneOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :selectedMilestoneInfoObj="getSelectedMilestoneInfoObj" @closeOverlay="handleCloseOverlay"></create-specific-element-completion-type-milestone-overlay>
      <update-specific-element-completion-type-milestone-overlay v-if="showUpdateSpecificElementCompletionTypeMilestoneOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :currSelectedMilestoneObjFromList="currSelectedExistingMilestoneObjFromList" @closeOverlay="handleCloseOverlay"></update-specific-element-completion-type-milestone-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteMilestoneString" v-bind:postfixString="postDeleteMilestoneString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="peformConfirmationAlertClickAction"></confirmation-alert>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { milestoneService } from '@/server-util/milestone-service'
import MilestoneActionOverlay from '@/components/MilestoneActionOverlay'
import CreateCumulativeProgressTypeMilestoneOverlay from '@/components/CreateCumulativeProgressTypeMilestoneOverlay'
import UpdateCumulativeProgressTypeMilestoneOverlay from '@/components/UpdateCumulativeProgressTypeMilestoneOverlay'
import CreateSpecificElementCompletionTypeMilestoneOverlay from '@/components/CreateSpecificElementCompletionTypeMilestoneOverlay'
import UpdateSpecificElementCompletionTypeMilestoneOverlay from '@/components/UpdateSpecificElementCompletionTypeMilestoneOverlay'
import filter from 'lodash/filter'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['selectedGroupObj'],
  created: function () {
    this.getPreviouslyCreatedMilestones(true)
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      selectedMilestoneInfoObj: -1,
      showCreateCumulativeProgressTypeMilestoneOverlay: false,
      showUpdateCumulativeProgressTypeMilestoneOverlay: false,
      showCreateSpecificElementCompletionTypeMilestoneOverlay: false,
      showUpdateSpecificElementCompletionTypeMilestoneOverlay: false,
      existingMilestoneList: [],
      showCreateMilestoneDropDownUI: false,
      currSelectedExistingMilestoneObjFromList: null,
      showingCreateOrUpdateOverlay: false,
      showConfirmationBox: false,
      prefixDeleteMilestoneString: '',
      postDeleteMilestoneString: '',
      showMilestoneActionOverlay: false
    }
  },
  name: 'MilestoneOverlayDiv',
  methods: {
    peformConfirmationAlertClickAction (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteMilestone()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    getMilestoneNameUsingMilestoneId: function (milestoneObj) {
      var currMileStoneObj = filter(this.getMilestoneInfoList, function (o) {
        return o.MilestoneInfoId === milestoneObj.MilestoneInfoId
      })
      if (currMileStoneObj !== undefined && currMileStoneObj !== null && currMileStoneObj !== 'null' && currMileStoneObj.length !== 0) {
        return currMileStoneObj[0].Title
      } else {
        return ''
      }
    },
    getMilestoneTypeUsingMilestoneId: function (milestoneObj) {
      var currMileStoneObj = filter(this.getMilestoneInfoList, function (o) {
        return o.MilestoneInfoId === milestoneObj.MilestoneInfoId
      })
      if (currMileStoneObj !== undefined && currMileStoneObj !== null && currMileStoneObj !== 'null' && currMileStoneObj.length !== 0) {
        return currMileStoneObj[0].Type
      } else {
        return null
      }
    },
    performClickOperation: function (event, selectedOperation, selectedMilestoneObj) {
      this.currSelectedExistingMilestoneObjFromList = selectedMilestoneObj
      switch (selectedOperation) {
        case 'action':
          this.showingCreateOrUpdateOverlay = true
          this.showMilestoneActionOverlay = true
          break
        case 'update':
          this.checkAndRenderRespectiveUpdateMilestoneUI()
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteMilestoneString = 'Are you sure you want to delete '
          this.postDeleteMilestoneString = '\'' + this.currSelectedExistingMilestoneObjFromList.Title + '\' milestone?'
          break
      }
    },
    updateCreateMilestoneDropDownFlag: function () {
      this.showCreateMilestoneDropDownUI = !this.showCreateMilestoneDropDownUI
      // AK: Reset previously selected milestone type to initial value if user revisited it
      if (this.showCreateMilestoneDropDownUI) {
        this.selectedMilestoneInfoObj = -1
      }
    },
    handleCloseOverlay (value) {
      const hasMilestoneCreatedOrUpdated = value.hasMilestoneCreatedOrUpdated
      const closeOverlay = value.closeOverlay
      const overlayType = value.type
      /*
        AK: Update gobal flag showingCreateOrUpdateOverlay to false for showing table list again.
        Since we are not closing current milestone listing overlay while opening create/update milestone
        pop-up hence doing such way.
      */
      this.showingCreateOrUpdateOverlay = false
      this.showCreateMilestoneDropDownUI = false
      switch (overlayType) {
        case 'action':
          this.selectedMilestoneInfoObj = -1
          this.showMilestoneActionOverlay = closeOverlay
          break
        case 'create':
          this.selectedMilestoneInfoObj = -1
          this.showCreateCumulativeProgressTypeMilestoneOverlay = closeOverlay
          this.showCreateSpecificElementCompletionTypeMilestoneOverlay = closeOverlay
          break
        case 'update':
          this.showUpdateCumulativeProgressTypeMilestoneOverlay = closeOverlay
          this.showUpdateSpecificElementCompletionTypeMilestoneOverlay = closeOverlay
          break
        default:
          this.showCreateCumulativeProgressTypeMilestoneOverlay = closeOverlay
          this.showUpdateCumulativeProgressTypeMilestoneOverlay = closeOverlay
          this.showCreateSpecificElementCompletionTypeMilestoneOverlay = closeOverlay
          this.showUpdateSpecificElementCompletionTypeMilestoneOverlay = closeOverlay
          this.showMilestoneActionOverlay = closeOverlay
          break
      }
      if (hasMilestoneCreatedOrUpdated) {
        this.getPreviouslyCreatedMilestones(false)
      }
    },
    closeMileStoneOverlay: function () {
      var obj = {
        closeOverlay: false
      }
      this.$emit('closeOverlay', obj)
    },
    getMilestoneInfo () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        // AK: If we don't have milestone list with us, then only show spinner to user.
        if (storeObj.state.milestoneInfoList.length === 0) {
          this.$store.state.isLoading = true
        }
        var _this = this
        milestoneService
          .getMilestoneInformation(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.isLoading = false
              storeObj.state.milestoneInfoList = responseObj.data
              if (storeObj.state.milestoneInfoList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Milestone(s) found.'
              }
              if (_this.$store.state.isLoading) {
                this.$store.state.isLoading = false
              }
            } else {
              if (_this.$store.state.isLoading) {
                this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading) {
              this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED LOADING MILESTONE INFO LIST OPERATION.')
      }
    },
    deleteMilestone () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        var _this = this
        _this.$store.state.isLoading = true
        milestoneService
          .deleteMilestone(
            storeObj.state.access_token,
            this.currSelectedExistingMilestoneObjFromList.MilestoneId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.getPreviouslyCreatedMilestones(false)
            } else {
              if (_this.$store.state.isLoading) {
                _this.$store.state.isLoading = false
              }
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading) {
              _this.$store.state.isLoading = false
            }
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              _this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              _this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED DELETE MILESTONE OPERATION.')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getSelectedMilestoneInfoObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a Milestone to create.'
        return false
      }
      return true
    },
    getPreviouslyCreatedMilestones: function (isComingFromOnCreate = false) {
      var storeObj = this.$store
      var _this = this
      _this.$store.state.isLoading = true
      if (
        this.getCurrentSelectedGroupObj !== undefined &&
        this.getCurrentSelectedGroupObj !== null &&
        this.getCurrentSelectedGroupObj !== 'null'
      ) {
        milestoneService
          .getMilestoneList(storeObj.state.access_token, this.getCurrentSelectedGroupObj.GroupId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.existingMilestoneList = responseObj.data
              // AK: Hide Spinner after recieving updated milestone list
              _this.$store.state.isLoading = false
              // AK: Get Milestone info
              if (isComingFromOnCreate) {
                _this.getMilestoneInfo()
              } else {
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'GROUP OBJECT IS NULL HENCE DECLINED LOADING EXISTING MILESTONE LIST OPERATION'
        )
      }
    },
    checkAndRenderRespectiveCreateMilestoneUI: function () {
      // AK: Update gobal flag showingCreateOrUpdateOverlay to true for hiding table list
      this.showingCreateOrUpdateOverlay = true
      const currSelectedMilestoneType = this.getSelectedMilestoneInfoObj.Type
      switch (currSelectedMilestoneType) {
        case constants.MilestoneInfoType.Cumulative_Progress:
          this.showCreateCumulativeProgressTypeMilestoneOverlay = true
          break
        case constants.MilestoneInfoType.Specific_Element_Completion:
          this.showCreateSpecificElementCompletionTypeMilestoneOverlay = true
          break
      }
    },
    checkAndRenderRespectiveUpdateMilestoneUI: function () {
      // AK: Update gobal flag showingCreateOrUpdateOverlay to true for hiding table list
      this.showingCreateOrUpdateOverlay = true
      const currSelectedMilestoneType = this.getMilestoneTypeUsingMilestoneId(this.currSelectedExistingMilestoneObjFromList)
      switch (currSelectedMilestoneType) {
        case constants.MilestoneInfoType.Cumulative_Progress:
          this.showUpdateCumulativeProgressTypeMilestoneOverlay = true
          break
        case constants.MilestoneInfoType.Specific_Element_Completion:
          this.showUpdateSpecificElementCompletionTypeMilestoneOverlay = true
          break
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'create-cumulative-progress-type-milestone-overlay': CreateCumulativeProgressTypeMilestoneOverlay,
    'update-cumulative-progress-type-milestone-overlay': UpdateCumulativeProgressTypeMilestoneOverlay,
    'create-specific-element-completion-type-milestone-overlay': CreateSpecificElementCompletionTypeMilestoneOverlay,
    'update-specific-element-completion-type-milestone-overlay': UpdateSpecificElementCompletionTypeMilestoneOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'milestone-action-overlay': MilestoneActionOverlay
  },
  computed: {
    getCurrentSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getMilestoneInfoList: {
      get: function () {
        return this.$store.state.milestoneInfoList
      }
    },
    getSelectedMilestoneInfoObj: {
      get: function () {
        return this.selectedMilestoneInfoObj
      },
      set: function (newValue) {
        this.selectedMilestoneInfoObj = newValue
        if (newValue !== -1) {
          this.checkAndRenderRespectiveCreateMilestoneUI()
        }
      }
    },
    getExistingMilestoneList: {
      get: function () {
        return this.existingMilestoneList
      },
      set: function (newValue) {
        this.existingMilestoneList = newValue
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.MilestoneOverlayDiv {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden{
  overflow-x: hidden !important;
}
.font-size-18px {
font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}

.grey-bottom-border {
  border-bottom: 1px solid #dddddd;
}

.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.font-weight-bold {
  font-weight: 700;
}
.opacity {
  opacity: 0.75;
}
.margin-top-1-perc {
  margin-top: 1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.border-right
{
  border-right: 1px solid #aaa !important;
}
</style>


// WEBPACK FOOTER //
// src/components/MilestoneOverlay.vue